import React from 'react';
import NeoBadge from '../../../../../components/Common/NeoBadge';
import { CONTACT_OUTCOME_ICONS, CONTACT_OUTCOME_LABELS } from '../../../../../constants/tasks';

const formatTimeAgo = (timestamp) => {
    if (!timestamp) return '';
    try {
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        return new Intl.DateTimeFormat('pt-BR', { 
            day: '2-digit', 
            month: 'short', 
            hour: '2-digit', 
            minute: '2-digit' 
        }).format(date);
    } catch {
        return '';
    }
};

const SidebarContactHistory = ({ outcomeHistory }) => {
    if (!outcomeHistory || outcomeHistory.length === 0) return null;

    return (
        <div className="mb-4">
            <h6 className="text-uppercase font-size-11 fw-bold text-brand-secondary mb-2">
                <i className="mdi mdi-history me-1"></i>
                Histórico de Contatos
            </h6>
            <ul className="list-unstyled mb-0 border-start ps-3 ms-2">
                {[...outcomeHistory].reverse().map((entry, idx) => (
                    <li key={idx} className="mb-3 position-relative">
                        <p className="mb-1 d-flex align-items-center gap-1">
                            {CONTACT_OUTCOME_ICONS[entry.outcome] && (
                                <i className={`mdi ${CONTACT_OUTCOME_ICONS[entry.outcome].icon} text-accent font-size-15`}></i>
                            )}
                            <NeoBadge 
                                color={entry.outcome === 'enrolled' || entry.outcome === 'renewed' ? 'success' : entry.outcome === 'gave_up' ? 'danger' : 'warning'}
                            >
                                {CONTACT_OUTCOME_LABELS[entry.outcome] || entry.outcome}
                            </NeoBadge>
                        </p>
                        {entry.notes && (
                            <p className="mb-1 text-brand-secondary fst-italic font-size-12">
                                "{entry.notes}"
                            </p>
                        )}
                        {entry.followUpDate && (
                            <p className="mb-1 d-flex align-items-center text-accent font-size-11 fw-bold">
                                <i className="mdi mdi-calendar-arrow-right me-1"></i>
                                Retorno: {entry.followUpDate.split('-').reverse().join('/')}
                            </p>
                        )}
                        <p className="mb-0 d-flex align-items-center text-muted font-size-11 fw-semibold">
                            <i className="mdi mdi-account-circle-outline me-1"></i>
                            {entry.user?.name || 'Sistema'}
                            <span className="mx-1">•</span>
                            {formatTimeAgo(entry.date)}
                        </p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SidebarContactHistory;
